export default __webpack_public_path__ + "static/media/Honored Helm of the Everlasting Sky.cab6640e.jpg";